module.exports = __webpack_public_path__ + "b9a90f648c36b5af4e31ba37048aea60.svg";